// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"5aa8cb3a","23":"06a55035","172":"87979f26","234":"70e6491e","309":"29f4da2c","359":"4437a089","511":"5d27a8af","835":"77627a71","874":"1caed30c","904":"605abc62","933":"9bd57dcb"}[chunkId] + ".chunk.js";
};